import {GetListParams, GetOneParams, GetManyParams, DeleteParams, Identifier, Sort, Pagination} from 'ra-core';

import {
   COLUMN_CATEGORY,
   COLUMN_HAIR_SERVICE,
   HASHTAG_CATEGORY,
   HASH_TAG,
   HASHTAG_MULTIPLE_LIST,
   HASHTAGS_LIST,
   HASHTAGS_LIST_TYPES,
   HASHTAG_CATEGORY_LIST,
   USER,
   COLUMN,
   STYLE_POST,
   HASHTAG_RECOMMEND_LIST,
   KEYWORDS,
   CAMPAIGN,
   VERSION,
   COUNTRY,
   CITY, AREA, SNAPSHOT,
   SNAPSHOT_HASHTAGS,
   SERVICES,
   SERVICES_CATEGORIES,
   COUNTRIES,
   CITIES,
   AREAS,
   CURRENCIES,
   REPORTS,
   IP_LIST_CONFIG,

   APP_VERSIONS, BONUS_TASK, BONUS_COUPON, BONUS_INFO_TAG
} from '../consts/Names';

export class PathCreator {
   static readonly LOGIN_PATH = 'api/admin/login';
   static readonly USERS_PATH = 'api/admin/users';
   static readonly CONTACT_PATH = 'api/admin/contact';
   static readonly USER_CONTACT_PATH = 'api/admin/users/contact';
   static readonly HASHTAGS_CATEGORIES_PATH = 'api/admin/hashtags/categories';
   static readonly HASHTAGS_PATH = 'api/admin/hashtags/tags';
   static readonly HASHTAG_LISTS_PATH = 'api/admin/hashtags/lists';
   static readonly HASHTAG_LISTS_TYPES_PATH = 'api/admin/hashtags/getListTypes';
   static readonly COLUMN_CATEGORIES_PATH = 'api/admin/articles/categories';
   static readonly COLUMN_CATEGORY_PATH = 'api/admin/articles/category';
   static readonly COLUMN_HAIR_SERVICE_PATH = '/api/admin/services';
   static readonly COLUMNS_PATH = 'api/admin/articles';
   static readonly COLUMN_PATH = 'api/admin/article';
   static readonly COLUMNS_DELETE_PATH = '/api/admin/articles/delete';
   static readonly STYLE_POST_PATH = 'api/admin/users/posts';
   static readonly REPORT_PATH_USER = 'api/admin/report/getByUser/';
   static readonly REPORT_PATH_POST = 'api/admin/report/getByPost/';
   static readonly REPORT_PATH_DELETE = 'api/admin/report/delete';
   static readonly REPORT_PATH_DELETE_MANY = 'api/admin/report/deleteMany';
   static readonly KEYWORDS_PATH = '/api/admin/keyword';
   static readonly VERSION_PATH = '/api/version';
   static readonly REPORTS_PATH = '/api/admin/report/get';
   static readonly STYLE_POST_LIST_PATH = '/api/admin/posts';
   static readonly STYLIST_PATH = '/api/stylist/update_post';
   static readonly NOTIFICATION_PATH = '/api/admin/notifications';
   static readonly CAMPAIGN_PATH = 'api/admin/campaigns';
   static readonly BONUS_TASKS_PATH = 'api/admin/bonus_tasks';
   static readonly BONUS_INFO_TAG = 'api/admin/bonus_info_tags';
   static readonly BONUS_COUPON_PATH = 'api/admin/bonus_coupons';
   static readonly ADMIN_VERSION_PATH = '/api/admin/version';
   static readonly COUNTRY_PATH = '/api/countries';
   static readonly CITY_PATH = '/api/cities';
   static readonly AREA_PATH = '/api/areas';
   static readonly SNAPSHOT_PATH = 'api/admin/snapshots';
   static readonly SNAPSHOT_HASHTAGS_PATH = 'api/admin/snapshots/hashtags/list';
   static readonly SERVICES_CATEGORIES_PATH = '/api/admin/services/categories';
   static readonly SERVICES_PATH = '/api/admin/services';
 
   static readonly COUNTRIES_PATH = '/api/admin/country';
   static readonly CITIES_PATH = '/api/admin/city';
   static readonly SMS_PROVIDERS_PATH = '/admin/api/sms_provider';
   static readonly ADMIN_USER_CREDS_PATH = '/api/admin/credentials';
   static readonly AREAS_PATH = '/api/admin/area';
   static readonly CURRENCIES_PATH = '/api/admin/currency';
   static readonly IP_LISTS_PATH = '/api/admin/ip_lists';
   static readonly IP_LIST_CONFIG_PATH = '/api/admin/twillio_config';
   static readonly SETTINGS_PATH = '/api/admin/settings';
   static readonly ADMIN_LOGS_PATH = '/api/admin/admin_logging';
   static readonly APP_VERSIONS_PATH = '/api/admin/app_versions';

   static GetPathBySource(source: string) {
      switch (source) {
         case USER.STYLIST_SOURCE:
         case USER.SOURCE:
            return this.USERS_PATH;
         case USER.USER_CONTACT:
            return this.USER_CONTACT_PATH;
         case COLUMN_CATEGORY.SOURCE:
            return this.COLUMN_CATEGORIES_PATH; 
         case COLUMN_HAIR_SERVICE.SOURCE:
            return this.COLUMN_HAIR_SERVICE_PATH;
         case HASHTAG_CATEGORY.SOURCE:
            return this.HASHTAGS_CATEGORIES_PATH;
         case HASH_TAG.SOURCE:
            return this.HASHTAGS_PATH;
         case HASHTAGS_LIST.SOURCE:
         case HASHTAG_CATEGORY_LIST.SOURCE:
         case HASHTAG_MULTIPLE_LIST.SOURCE:
         case HASHTAG_RECOMMEND_LIST.SOURCE:
            return this.HASHTAG_LISTS_PATH;
         case HASHTAGS_LIST_TYPES.SOURCE:
            return this.HASHTAG_LISTS_TYPES_PATH;
         case COLUMN.SOURCE:
            return this.COLUMNS_PATH;
         case COUNTRY.SOURCE:
            return this.COUNTRY_PATH;
         case CITY.SOURCE:
            return this.COUNTRY_PATH;
         case AREA.SOURCE:
            return this.COUNTRY_PATH;
         case STYLE_POST.SOURCE:
            return this.STYLE_POST_PATH;
         case BONUS_TASK.SOURCE:
            return this.BONUS_TASKS_PATH;
         case BONUS_INFO_TAG.SOURCE:
            return this.BONUS_INFO_TAG;
         case BONUS_COUPON.SOURCE:
            return this.BONUS_COUPON_PATH;
         case SNAPSHOT.SOURCE:
            return this.SNAPSHOT_PATH;
         case SNAPSHOT_HASHTAGS.SOURCE:
            return this.SNAPSHOT_HASHTAGS_PATH;
         case KEYWORDS.SOURCE:
            return this.KEYWORDS_PATH;
         case CAMPAIGN.SOURCE:
            return this.CAMPAIGN_PATH;
         case VERSION.SOURCE:
            return this.VERSION_PATH; 
         case IP_LIST_CONFIG.SOURCE:
            return this.IP_LIST_CONFIG_PATH;
         case SERVICES.SOURCE:
            return this.SERVICES_PATH;
         case SERVICES_CATEGORIES.SOURCE:
            return this.SERVICES_CATEGORIES_PATH;
         case COUNTRIES.SOURCE:
            return this.COUNTRIES_PATH;
         case CITIES.SOURCE:
            return this.CITIES_PATH;
         case AREAS.SOURCE:
            return this.AREAS_PATH;
         case CURRENCIES.SOURCE:
            return this.CURRENCIES_PATH; 
         case REPORTS.SOURCE:
            return this.REPORTS_PATH;
         case APP_VERSIONS.SOURCE:
            return this.APP_VERSIONS_PATH;
         default:
            return '';
      }
   }

   static getFilter = (filter: Object) => {
      const keys = Object.keys(filter || {});
      if (keys.length === 0) return '';
      let query = '';
      keys.forEach((key) => {
         query += '&' + key + '=' + encodeURIComponent(filter[key]);
      });
      return query.substring(1);
   };

   static getSort = (sort: Sort) => {
      if (sort === undefined || sort.field === (undefined || '') || sort.order === (undefined || '')) return '';
      return '&sort=' + sort.field + '&order=' + sort.order?.toLowerCase();
   };

   static getRange = (pagination: Pagination) => {
      if (pagination === undefined || pagination.page === (undefined || -1) || pagination.perPage === (undefined || -1)) return '';
      return 'paginate=' + pagination.perPage + '&page=' + pagination.page;
   };

   static GetAllItems(path: string, params: GetListParams) {
      const {pagination, sort, filter} = params;
      const paginated = PathCreator.getRange(pagination);
      const sorted = PathCreator.getSort(sort);
      const filtered = PathCreator.getFilter(filter);
      let requestPath = paginated.length ? paginated + '&' : '';
      requestPath += sorted.length ? sorted + '&' : '';
      requestPath += filtered.length ? filtered : '';
      // requestPath = requestPath.replaceAll('&&', '&');
      return path + '?' + requestPath;
   }

   static GetExportSelectedItems(path: string, params: GetListParams, ids: GetManyParams) {
      return this.GetAllItems(path, params) + (ids?.ids?.length ? ('&ids=' + ids.ids.join(',')) : '');
   }

   static GetOneItem = (path: string, params: GetOneParams) => {
      const {id} = params;
      return path + '/' + id;
   };

   static DeleteItem = (path: string, params: DeleteParams) => {
      const {id} = params;
      return path + '/' + id;
   };

   static PathWithID = (path: string, id: Identifier) => {
      return path + '/' + id;
   };

   static PathWithIdAndRest = (path: string, id: Identifier, rest: string = '') => {
      return path + '/' + id + '/' + rest;
   };
}
